export default _this => {
  _this.columns = [
    "name",
    "type",
    "per_user",
    "mode",
    "period",
    "currency",
    "black_a4",
    "color_a4",
    "black_a3",
    "color_a3",
    "scan"
  ];

  _this.data = [];
  _this.data.push({
    DT_RowId: "default",
    name: "General",
    type: "balance",
    per_user: "true",
    // only relevant for quota mode
    // mode: "increment",
    // period: "monthly",
    currency: "ILS",
    black_a4: 0.2,
    color_a4: 1.5,
    black_a3: 0.2,
    color_a3: 1.5,
    scan: 0.06
  });

  if (_this.user.settings && _this.user.settings.policies) {
    const { policies } = _this.user.settings;
    for (const policyId of Object.keys(policies)) {
      const policy = policies[policyId];
      const row = {
        DT_RowId: policyId,
        name: policy.name
      };
      _this.data.push(row);
    }
  }

  $.each(_this.unique(_this.columns), (index, column) => {
    let title = column;
    let uniqueColumn = { data: column };
    let visible = true;
    uniqueColumn["title"] = _this.t(title);
    uniqueColumn["visible"] = visible;
    uniqueColumn["name"] = column;
    _this.uniqueColumns.push(uniqueColumn);
  });

  const { options } = _this.createTableProperties(_this);
  _this.table = $(_this.$el)
    .find("table")
    .DataTable(options);
  const fields = [
    {
      label: `${_this.t("Name")}`,
      name: "name"
    }
  ];

  const ajax = (method, url, d, success, error) => {
    let output = { data: [] };
    switch (d.action) {
      case "create":
        const policy = d.data[0];
        const policyId = _this.uuidv4();
        const update = {};
        update[`settings.policies.${policyId}`] = JSON.parse(
          JSON.stringify(policy)
        );
        policy.DT_RowId = policyId;
        output.data.push(policy);
        success(output);
        _this.$store.state.db
          .collection("users")
          .doc(_this.ref.id)
          .update(update);
        break;
      case "edit": {
        (async () => {
          const update = {};
          for (const id of Object.keys(d.data)) {
            const value = d.data[id];
            const rowData = _this.table.row("#" + id).data();
            const data = $.extend({}, rowData, value);
            const newData = $.extend(
              {},
              _this.user.settings.policies[id],
              value
            );
            update[`settings.policies.${id}`] = newData;
            output.data.push(data);
          }
          success(output);
          try {
            await _this.$store.state.db
              .collection("users")
              .doc(_this.ref.id)
              .update(update);
          } catch (e) {
            console.log(e);
          }
        })();
        break;
      }
      case "remove":
        success(output);
        async.eachOf(
          d.data,
          (value, id, callback) => {
            // const update = {};
            // update[
            //   `settings.policies.${id}`
            // ] = _this.firebase.firestore.FieldValue.delete();
            // todo: check if users exists with the same policy and prevent deleting the policy if yes.
            // _this.$store.state.db
            //   .collection("users")
            //   .doc(_this.ref.id)
            //   .update(update)
            //   .then(() => callback());
          },
          error => {
            // todo: check if groups exists with the same policy and prevent deleting the policy if yes.
          }
        );
        break;
    }
  };
  const editor = _this.createEditor(_this, fields, ajax);
  const buttons1 = [
    {
      extend: "create",
      editor,
      text: '<span class="icon s7-plus"></span>',
      titleAttr: _this.t("Add"),
      formTitle: (editor, dt) => editor.i18n.create.title
    },
    {
      extend: "edit",
      editor: editor,
      text: '<span class="icon s7-pen"></span>',
      titleAttr: _this.t("Edit"),
      formTitle: (editor, dt) => editor.i18n.edit.title
    },
    {
      extend: "remove",
      editor,
      text: '<span class="icon s7-trash"></span>',
      titleAttr: _this.t("Remove")
    }
  ];
  const buttons2 = [];
  _this.createButtons(_this, buttons1, buttons2);
};



// WEBPACK FOOTER //
// ./src/mixins/Policies.js